module.exports = __webpack_public_path__ + "static/media/ve.da0049c4.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/ve.svg
// module id = 2240
// module chunks = 0